import React, { ReactElement } from "react";
import useRouting, { Navigate } from "../contexts/Routing";
import useCurrentSession from "../contexts/UserContext";

interface AuthRouteProps {
    component?: () => ReactElement;
    children?: ReactElement;
}

/*
 * A component that redirects to login if authentication is false
 * If authentication is true, then the child component is rendered
 */
export default function AuthRoute(props: AuthRouteProps) : ReactElement | null {
    const { isLoggedIn } = useCurrentSession();
    const { Paths } = useRouting();

    if (!isLoggedIn) {
        return <Navigate to={Paths.LOGIN} search={{ redirect: window.location.href }} />;
    }

    const Component = props.component as () => ReactElement;

    return (props.children ?? <Component />);
}

AuthRoute.defaultProps = {
    component: undefined,
    children: undefined,
};
